var $ = require('jquery');

function init() {
	function Accordion() {
	}
	
	Accordion.prototype.activate = function () {
		this.attachHandlers('languageSelector__selection');
		this.escapeAccordion('languageSelector__selection');
	};
	
	Accordion.prototype.attachHandlers = function (item) {
		var that = this;
	
		$(document).on('click', '.' + item, function(event) {
			event.preventDefault();

			that.toggleAccordion(item);
		});
	};
	
	Accordion.prototype.toggleAccordion = function (item) {
		if ($('.' + item).hasClass(item + '--active')) {
			$('.' + item).removeClass(item + '--active');
		} else {
			$('.' + item).addClass(item + '--active');
		}
	};
	
	Accordion.prototype.escapeAccordion = function (item) {
		var closeAccordion = function() {
			var toClose = $('.' + item + '--active');
			if (toClose.length === 0) {
				return false;
			}
			toClose.removeClass(item + '--active');
			return true;
		};
		$(window).on('click touchstart', function(event) {
			if ((event.target).closest('.languageSelector__drawer') || (event.target).closest('.' + item + '--active')) {
				return;
			}
			closeAccordion();
		});
		$(document).on('keyup', function(e) {
			if (e.key === "Escape") { // escape key maps to keycode `27`
				if (!closeAccordion()) {
					closeAccordion();
				}
			}
		});
	};

	var languageSelectorToggle = new Accordion();
	languageSelectorToggle.activate();



	$('.jsAutoSubmitOnChange').on('change', function() {
		$(this).closest('form').submit();
	});
}

module.exports = {
	init: init
}